// extracted by mini-css-extract-plugin
export default {"container":"App_container__5tvB3","info":"App_info__iPcSP"};